// Story 8.10 (ADO-2019), AC1 / AC2 / DV-37: the "HHT Orders" link to `/hht-orders` with
// its waiting-count badge. One markup for `SiteHeader` and the app's chooser header (on
// /choose and the HHT pages); each host passes its own classes, so the link sits in its
// bar's layout. The count is in the accessible name; the badge is visual.
import { Link } from 'react-router';
import { Icon } from '../Icon/Icon';

/** CSS module class names (a module lookup is typed `string | undefined`). */
export interface HhtOrdersLinkClasses {
  readonly link: string | undefined;
  readonly label: string | undefined;
  readonly badge: string | undefined;
}

export function HhtOrdersLink({
  waitingCount,
  classes,
}: {
  readonly waitingCount: number;
  readonly classes: HhtOrdersLinkClasses;
}) {
  return (
    <Link
      to="/hht-orders"
      className={classes.link}
      aria-label={waitingCount > 0 ? `HHT Orders, ${waitingCount} waiting` : 'HHT Orders'}
    >
      <Icon name="deviceMobile" size={18} />
      <span className={classes.label}>HHT Orders</span>
      {waitingCount > 0 ? (
        <span className={classes.badge} aria-hidden data-testid="hht-orders-badge">
          {waitingCount}
        </span>
      ) : null}
    </Link>
  );
}
